// AP-080/AP-161/AP-167 · Sino de Notificações do Portal — estado global via
// PortalNotificationsContext (sincronizado em tempo real com a página
// `Notificações` e com `markReadByProcess`).
import React from "react";
import { NavLink } from "react-router-dom";
import { Bell } from "lucide-react";
import { usePortalNotifications } from "../../context/PortalNotificationsContext";
import { usePortalI18n } from "./PortalI18nContext";

export default function PortalNotificationBell({ className = "" }) {
  const { unread } = usePortalNotifications();
  const { t } = usePortalI18n();
  const ariaKey = unread === 0 ? "bell.aria" : (unread === 1 ? "bell.ariaCountOne" : "bell.ariaCount");
  const aria = t(ariaKey).replace("{n}", String(unread));

  return (
    <NavLink
      to="/portal/notifications"
      data-testid="portal-notification-bell"
      className={({ isActive }) =>
        `relative inline-flex h-10 w-10 items-center justify-center rounded-full border border-transparent transition-all duration-150 active:scale-95 ${
          isActive ? "bg-primary/10 text-primary border-primary/30" : "text-muted-foreground hover:text-foreground hover:bg-muted/60"
        } ${className}`
      }
      aria-label={aria}
    >
      <Bell className="h-5 w-5" strokeWidth={2} />
      {unread > 0 && (
        <span
          data-testid="portal-notification-bell-badge"
          className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold grid place-items-center shadow-md animate-in zoom-in-50 duration-200 tabular-nums"
        >
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </NavLink>
  );
}
